export default {
    data(){
        return{
            forceKey: -1,
        };
    },
    methods: {
        forceKey_forceKeyChange(){
            this.forceKey = Math.random() * 1200;
            // console.log('forceKey', this.forceKey);
        }
    },
}